module.exports = __webpack_public_path__ + "components/intersport-discount-page/static/intersport-1200@2x-7b96a7f71ff403a3ac5f0af67cd2fa68.webp";